define('modules/login/service/CredenzialiUtente',[], function() {
    var Service = function(LocalStorage) {

        var RICORDA_PASSWORD_KEY = 'RICORDA_PASSWORD';
        var USERNAME_KEY = 'USERNAME';
        var PASSWORD_KEY = 'PASSWORD';
        var ALIAS_KEY = 'ALIAS';

        return {
            getRicordaPassword: function() {
                return LocalStorage.getItem(RICORDA_PASSWORD_KEY, false);
            },
            setRicordaPassword: function(ricordaPassword) {
                LocalStorage.setItem(RICORDA_PASSWORD_KEY, ricordaPassword);
                return ricordaPassword;
            },
            getUsername: function() {
                return LocalStorage.getItem(USERNAME_KEY);
            },
            setUsername: function(username) {
                return LocalStorage.setItem(USERNAME_KEY, username);
            },
            getPassword: function() {
                return LocalStorage.getItem(PASSWORD_KEY);
            },
            setPassword: function(password) {
                return LocalStorage.setItem(PASSWORD_KEY, password);
            },
            getAlias: function() {
                return LocalStorage.getItem(ALIAS_KEY);
            },
            setAlias: function(alias) {
                return LocalStorage.setItem(ALIAS_KEY, alias);
            },
            reset: function() {
                this.setPassword(null);
                this.setUsername(null);
                this.setAlias(null);
                this.setRicordaPassword(false);
            }
        };
    };

    return ["LocalStorage", Service];
});
